import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitofivejyotilingacab() {



    const cardData = {




keyword: "Mumbai to 5 Jyotirlinga Cab",

headingDescription: "Shreesha Tours & Travels offers reliable and comfortable Mumbai to 5 Jyotirlinga cab services for devotees, families, senior citizens, and pilgrimage groups seeking a spiritual journey across Maharashtra. We provide customized 5 Jyotirlinga tour packages, one-way cabs, round-trip taxi services, and multi-day pilgrimage tours with experienced chauffeurs and well-maintained vehicles. Our fleet includes Sedan, Swift Dzire, Ertiga, SUV, Innova, Innova Crysta, Tempo Traveller, Urbania, Mini Bus, and luxury vehicles suitable for every group size and travel budget. With doorstep pickup anywhere in Mumbai, flexible travel schedules, transparent pricing, easy online booking, and 24/7 customer support, Shreesha Tours & Travels ensures a safe, comfortable, and hassle-free pilgrimage experience. Whether you are planning a family religious tour, a group yatra, or a personalized Jyotirlinga pilgrimage, our professional drivers and clean vehicles provide a smooth travel experience while covering the sacred Jyotirlingas and nearby spiritual destinations across Maharashtra.",

topPlaces: [
  {
    title: "Bhimashankar Jyotirlinga",
    description: "Bhimashankar Temple, located amidst the Sahyadri Hills, is one of the twelve sacred Jyotirlingas dedicated to Lord Shiva. Surrounded by dense forests and the Bhimashankar Wildlife Sanctuary, it attracts thousands of devotees seeking blessings, spiritual peace, and scenic natural beauty throughout the year."
  },
  {
    title: "Trimbakeshwar Jyotirlinga",
    description: "Trimbakeshwar Temple near Nashik is one of the holiest Jyotirlingas in India and is situated at the origin of the sacred Godavari River. The temple is famous for its ancient architecture, spiritual significance, and religious rituals performed by devotees from across the country."
  },
  {
    title: "Grishneshwar Jyotirlinga",
    description: "Grishneshwar Temple, located near the UNESCO-listed Ellora Caves, is the twelfth Jyotirlinga of Lord Shiva. The temple is admired for its beautiful stone carvings, peaceful atmosphere, and historical importance, making it an essential stop during the 5 Jyotirlinga pilgrimage."
  },
  {
    title: "Aundha Nagnath Jyotirlinga",
    description: "Aundha Nagnath Temple in Hingoli district is believed by many devotees to be one of the original Jyotirlinga shrines. The temple is known for its ancient Hemadpanthi architecture, spiritual significance, and serene surroundings that attract pilgrims throughout the year."
  },
  {
    title: "Parli Vaijnath Jyotirlinga",
    description: "Parli Vaijnath Temple is one of Maharashtra's most revered Shiva temples and an important destination in the 5 Jyotirlinga circuit. Devotees visit the temple seeking blessings for health, prosperity, and spiritual well-being while admiring its traditional architecture."
  },
  {
    title: "Ellora Caves",
    description: "Located close to Grishneshwar Temple, Ellora Caves are a UNESCO World Heritage Site featuring magnificent Buddhist, Hindu, and Jain rock-cut monuments. The world-famous Kailasa Temple is one of the finest examples of ancient Indian architecture and craftsmanship."
  },
  {
    title: "Shirdi",
    description: "Shirdi is one of India's most visited pilgrimage destinations and home to the sacred Shri Sai Baba Samadhi Mandir. Many travelers include Shirdi in their 5 Jyotirlinga pilgrimage for a more fulfilling spiritual journey across Maharashtra."
  },
  {
    title: "Nashik",
    description: "Nashik is a major religious city famous for Trimbakeshwar Temple, Panchavati, Ram Kund, and the sacred Godavari River. It serves as an important stop during the Jyotirlinga pilgrimage and offers several historical and spiritual attractions."
  },
  {
    title: "Aurangabad",
    description: "Aurangabad is a heritage city that serves as the gateway to Grishneshwar Temple, Ellora Caves, Ajanta Caves, and Bibi Ka Maqbara. It is frequently included in extended pilgrimage and heritage tours across Maharashtra."
  },
  {
    title: "Shani Shingnapur",
    description: "Shani Shingnapur is a renowned pilgrimage destination dedicated to Lord Shani and is famous for its unique tradition of homes without doors. Many devotees include this sacred temple while traveling on the 5 Jyotirlinga route from Mumbai."
  }
],



"services": [
  {
    "name": "Mumbai to 5 Jyotirlinga Cab",
    "description": "Book Mumbai to 5 Jyotirlinga Cab for a safe, comfortable, and spiritual pilgrimage with professional chauffeurs and well-maintained AC vehicles. Choose Sedan, Ertiga, Innova Crysta, SUV, Tempo Traveller, and luxury cabs for a complete Maharashtra Jyotirlinga tour."
  },
  {
    "name": "Mumbai to 5 Jyotirlinga Tour Package",
    "description": "Choose Mumbai to 5 Jyotirlinga Tour Package with customized itineraries, experienced drivers, and comfortable vehicles for a hassle-free pilgrimage."
  },
  {
    "name": "Mumbai to 5 Jyotirlinga Taxi Service",
    "description": "Book Mumbai to 5 Jyotirlinga Taxi Service with reliable chauffeurs, clean AC vehicles, and affordable tour packages for temple visits."
  },
  {
    "name": "Mumbai to 5 Jyotirlinga Cab Service",
    "description": "Hire Mumbai to 5 Jyotirlinga Cab Service with premium vehicles and professional drivers for a comfortable multi-day pilgrimage."
  },
  {
    "name": "Mumbai to 5 Jyotirlinga Darshan Package",
    "description": "Reserve Mumbai to 5 Jyotirlinga Darshan Package with comfortable transportation and flexible schedules for all five Jyotirlinga temples in Maharashtra."
  },
  {
    "name": "Mumbai to 5 Jyotirlinga Yatra Cab",
    "description": "Book Mumbai to 5 Jyotirlinga Yatra Cab with experienced chauffeurs and spacious AC vehicles for a peaceful religious journey."
  },
  {
    "name": "Mumbai to 5 Jyotirlinga Tour Cab",
    "description": "Choose Mumbai to 5 Jyotirlinga Tour Cab with reliable long-distance travel and convenient temple sightseeing."
  },
  {
    "name": "Mumbai to 5 Jyotirlinga Taxi",
    "description": "Hire Mumbai to 5 Jyotirlinga Taxi with affordable pricing, professional drivers, and comfortable vehicles."
  },
  {
    "name": "Mumbai to 5 Jyotirlinga Car Rental",
    "description": "Reserve Mumbai to 5 Jyotirlinga Car Rental with chauffeur-driven Sedan, Ertiga, Innova Crysta, SUV, and luxury cars."
  },
  {
    "name": "Mumbai to 5 Jyotirlinga Package by Cab",
    "description": "Book Mumbai to 5 Jyotirlinga Package by Cab with complete pilgrimage planning, comfortable travel, and experienced chauffeurs."
  },
  {
    "name": "Mumbai to 5 Jyotirlinga Innova Cab",
    "description": "Choose Mumbai to 5 Jyotirlinga Innova Cab for spacious family travel and comfortable temple tours."
  },
  {
    "name": "Mumbai to 5 Jyotirlinga Innova Crysta Cab",
    "description": "Book Mumbai to 5 Jyotirlinga Innova Crysta Cab for premium comfort, luxury seating, and long-distance pilgrimage travel."
  },
  {
    "name": "Mumbai to 5 Jyotirlinga Ertiga Cab",
    "description": "Hire Mumbai to 5 Jyotirlinga Ertiga Cab for affordable 6 to 7 seater travel with comfortable interiors."
  },
  {
    "name": "Mumbai to 5 Jyotirlinga Kia Carens Cab",
    "description": "Reserve Mumbai to 5 Jyotirlinga Kia Carens Cab for modern family travel with spacious seating and premium comfort."
  },
  {
    "name": "Mumbai to 5 Jyotirlinga SUV Taxi",
    "description": "Book Mumbai to 5 Jyotirlinga SUV Taxi for group travel with additional luggage space and comfortable seating."
  },
  {
    "name": "Mumbai to 5 Jyotirlinga Sedan Cab",
    "description": "Choose Mumbai to 5 Jyotirlinga Sedan Cab for economical and comfortable pilgrimage travel."
  },
  {
    "name": "Mumbai to 5 Jyotirlinga Tempo Traveller",
    "description": "Hire Mumbai to 5 Jyotirlinga Tempo Traveller for group tours, family pilgrimages, and religious travel."
  },
  {
    "name": "Mumbai to 5 Jyotirlinga Luxury Cab",
    "description": "Book Mumbai to 5 Jyotirlinga Luxury Cab for premium chauffeur-driven travel with luxury vehicles."
  },
  {
    "name": "Mumbai to 5 Jyotirlinga AC Taxi",
    "description": "Reserve Mumbai to 5 Jyotirlinga AC Taxi with clean air-conditioned vehicles and experienced professional drivers."
  },
  {
    "name": "Mumbai to 5 Jyotirlinga Family Tour Cab",
    "description": "Choose Mumbai to 5 Jyotirlinga Family Tour Cab for comfortable family pilgrimage with spacious vehicles."
  },
  {
    "name": "Mumbai to Bhimashankar Cab",
    "description": "Book Mumbai to Bhimashankar Cab for convenient Jyotirlinga darshan with reliable chauffeurs and comfortable vehicles."
  },
  {
    "name": "Mumbai to Trimbakeshwar Cab",
    "description": "Hire Mumbai to Trimbakeshwar Cab for safe pilgrimage travel with experienced drivers and AC vehicles."
  },
  {
    "name": "Mumbai to Grishneshwar Cab",
    "description": "Reserve Mumbai to Grishneshwar Cab with affordable fares and comfortable long-distance transportation."
  },
  {
    "name": "Mumbai to Parli Vaijnath Cab",
    "description": "Book Mumbai to Parli Vaijnath Cab for smooth temple travel with premium chauffeur-driven vehicles."
  },
  {
    "name": "Mumbai to Aundha Nagnath Cab",
    "description": "Choose Mumbai to Aundha Nagnath Cab for reliable pilgrimage travel with professional drivers."
  },
  {
    "name": "Mumbai to Bhimashankar Trimbakeshwar Tour",
    "description": "Book Mumbai to Bhimashankar Trimbakeshwar Tour with customized temple sightseeing and comfortable cab service."
  },
  {
    "name": "Mumbai to Grishneshwar Jyotirlinga Taxi",
    "description": "Reserve Mumbai to Grishneshwar Jyotirlinga Taxi for hassle-free temple travel with experienced chauffeurs."
  },
  {
    "name": "Mumbai to Parli Vaijnath Tour Package",
    "description": "Choose Mumbai to Parli Vaijnath Tour Package with complete travel planning and comfortable vehicles."
  },
  {
    "name": "Mumbai to Aundha Nagnath Darshan Cab",
    "description": "Book Mumbai to Aundha Nagnath Darshan Cab with flexible schedules and reliable chauffeur-driven transportation."
  },
  {
    "name": "Maharashtra 5 Jyotirlinga Tour from Mumbai",
    "description": "Plan Maharashtra 5 Jyotirlinga Tour from Mumbai with premium cab services, experienced drivers, and customized pilgrimage packages covering all five Jyotirlinga temples."
  }
],
"tableData": [
  ["Mumbai to 5 Jyotirlinga Cab", "Mumbai to 5 Jyotirlinga Tour Package"],
  ["Mumbai to 5 Jyotirlinga Taxi Service", "Mumbai to 5 Jyotirlinga Cab Service"],
  ["Mumbai to 5 Jyotirlinga Darshan Package", "Mumbai to 5 Jyotirlinga Yatra Cab"],
  ["Mumbai to 5 Jyotirlinga Tour Cab", "Mumbai to 5 Jyotirlinga Taxi"],
  ["Mumbai to 5 Jyotirlinga Car Rental", "Mumbai to 5 Jyotirlinga Package by Cab"],
  ["Mumbai to 5 Jyotirlinga Innova Cab", "Mumbai to 5 Jyotirlinga Innova Crysta Cab"],
  ["Mumbai to 5 Jyotirlinga Ertiga Cab", "Mumbai to 5 Jyotirlinga Kia Carens Cab"],
  ["Mumbai to 5 Jyotirlinga SUV Taxi", "Mumbai to 5 Jyotirlinga Sedan Cab"],
  ["Mumbai to 5 Jyotirlinga Tempo Traveller", "Mumbai to 5 Jyotirlinga Luxury Cab"],
  ["Mumbai to 5 Jyotirlinga AC Taxi", "Mumbai to 5 Jyotirlinga Family Tour Cab"],
  ["Mumbai to Bhimashankar Cab", "Mumbai to Trimbakeshwar Cab"],
  ["Mumbai to Grishneshwar Cab", "Mumbai to Parli Vaijnath Cab"],
  ["Mumbai to Aundha Nagnath Cab", "Mumbai to Bhimashankar Trimbakeshwar Tour"],
  ["Mumbai to Grishneshwar Jyotirlinga Taxi", "Mumbai to Parli Vaijnath Tour Package"],
  ["Mumbai to Aundha Nagnath Darshan Cab", "Maharashtra 5 Jyotirlinga Tour from Mumbai"]
],




whychoose: [
  {
    WhyChooseheading: "Reliable Mumbai to 5 Jyotirlinga Cab Service",
    WhyChoosedescription: "Shreesha Tours & Travels offers comfortable Mumbai to 5 Jyotirlinga cab services with experienced drivers, well-maintained vehicles, and customized pilgrimage packages for a peaceful spiritual journey."
  },
  {
    WhyChooseheading: "Complete 5 Jyotirlinga Pilgrimage Tour",
    WhyChoosedescription: "Visit the famous Jyotirlinga temples including Bhimashankar, Trimbakeshwar, Grishneshwar, Aundha Nagnath, and Parli Vaijnath with a private cab designed for a comfortable and memorable yatra."
  },
  {
    WhyChooseheading: "Wide Choice of Comfortable Vehicles",
    WhyChoosedescription: "Select from Swift Dzire, Sedan, Ertiga, Innova, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles according to your group size and travel preferences."
  },
  {
    WhyChooseheading: "Flexible Multi-Day Tour Packages",
    WhyChoosedescription: "Choose from customized 3-day, 4-day, 5-day, or extended pilgrimage packages with flexible pickup, return schedules, and sightseeing options."
  },
  {
    WhyChooseheading: "Experienced Chauffeurs for Long Routes",
    WhyChoosedescription: "Our professional drivers are familiar with all major pilgrimage routes and ensure a safe, comfortable, and timely journey throughout your 5 Jyotirlinga tour."
  },
  {
    WhyChooseheading: "Customizable Religious Itinerary",
    WhyChoosedescription: "You can add nearby temples and attractions such as Shirdi Sai Baba, Shani Shingnapur, Ellora Caves, Ajanta Caves, Tuljapur, or other destinations according to your travel plan."
  },
  {
    WhyChooseheading: "Comfortable & Well-Maintained Fleet",
    WhyChoosedescription: "Travel in clean, air-conditioned vehicles with spacious seating and ample luggage space, making long-distance pilgrimage journeys relaxing for every passenger."
  },
  {
    WhyChooseheading: "Easy Booking with Shreesha Tours & Travels",
    WhyChoosedescription: "Book your Mumbai to 5 Jyotirlinga cab with transparent pricing, dedicated customer support, and personalized travel assistance for a hassle-free pilgrimage."
  }
]

};

const faqData = [
  {
    question: "Does Shreesha Tours & Travels provide Mumbai to 5 Jyotirlinga Cab Service?",
    answer: "Yes, we provide private cab services from Mumbai for customized 5 Jyotirlinga pilgrimage tours."
  },
  {
    question: "Which Jyotirlingas are covered in the 5 Jyotirlinga tour?",
    answer: "The package can include Bhimashankar, Trimbakeshwar, Grishneshwar, Aundha Nagnath, and Parli Vaijnath. The itinerary can also be customized according to your preference."
  },
  {
    question: "Which vehicles are available for the pilgrimage tour?",
    answer: "You can choose from Swift Dzire, Sedan, Ertiga, Innova, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles."
  },
  {
    question: "Can I customize the 5 Jyotirlinga tour itinerary?",
    answer: "Yes, the tour itinerary can be customized based on the temples you wish to visit, travel duration, and sightseeing preferences."
  },
  {
    question: "Is the cab suitable for family pilgrimage travel?",
    answer: "Yes, our comfortable vehicles are ideal for families, senior citizens, groups, and devotees travelling together."
  },
  {
    question: "Can I include Shirdi and Shani Shingnapur in the trip?",
    answer: "Yes, nearby pilgrimage destinations like Shirdi, Shani Shingnapur, Ellora Caves, Ajanta Caves, and Tuljapur can be added to your itinerary."
  },
  {
    question: "Do you provide pickup from Mumbai Airport and hotels?",
    answer: "Yes, pickup is available from Mumbai Airport, railway stations, hotels, homes, offices, and any preferred location in Mumbai."
  },
  {
    question: "Are tolls and parking charges included in the package?",
    answer: "Toll charges, parking fees, permits, and other applicable expenses depend on the selected package and are explained during booking."
  },
  {
    question: "Is Mumbai to 5 Jyotirlinga cab service available throughout the year?",
    answer: "Yes, Shreesha Tours & Travels provides cab services throughout the year based on advance booking and vehicle availability."
  },
  {
    question: "How can I book a Mumbai to 5 Jyotirlinga Cab?",
    answer: "Share your travel date, pickup location, number of passengers, preferred vehicle, and tour duration to receive your customized quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Vinod Joshi",
    feedback: "Our 5 Jyotirlinga pilgrimage with Shreesha Tours & Travels was perfectly organized. The driver was knowledgeable, the Innova Crysta was comfortable, and the entire journey was smooth and peaceful.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Shalini Deshpande",
    feedback: "We travelled with our family for the 5 Jyotirlinga Darshan. The vehicle was clean, the driver was punctual, and every part of the journey was managed professionally.",
    rating: 5
  }
];





    const Images = [
        { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
        { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
        { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
        { place: "/images/keyword/5.jpg", text: "Mumbai to Nashik Cab", link: "Mumbai-to-Nashik-Cab" },
        { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
        { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
        { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
        { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
        { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
        { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
        { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
        { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
        { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
        { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
        { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
        { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
        { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
        { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
        { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
        { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
        { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
        { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
        { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
    ];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to 5 Jyotirlinga Cab",
  "image": "https://www.shreeshatravels.com/assets/images/mumbai-to-5-jyotirlinga-cab.webp",
  "description":
    "Book Mumbai to 5 Jyotirlinga Cab with Shreesha Tours & Travels for safe, comfortable, and affordable pilgrimage taxi services. We provide one-way and round-trip cabs from Mumbai for the 5 Jyotirlinga Darshan with Sedan, Ertiga, SUV, Innova, and Innova Crysta available 24x7 for temple visits, family tours, religious travel, and customized pilgrimage packages.",
  "brand": {
    "@type": "Brand",
    "name": "Shreesha Tours & Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shreeshatravels.com/mumbai-to-5-jyotirlinga-cab"
  }
};



    return (
        <div>

<Helmet>
  <title>Mumbai to 5 Jyotirlinga Cab | Sacred Tour Package | +91 8355835813</title>

  <meta
    name="description"
    content="Book Mumbai to 5 Jyotirlinga Cab with Shreesha Travels for reliable pilgrimage taxi services. Hire Sedan, Ertiga, SUV, Innova, and Innova Crysta for comfortable 5 Jyotirlinga Darshan tours with affordable fares, customized packages, and 24x7 online cab booking."
  />

  <meta
    name="keywords"
    content="Mumbai to 5 Jyotirlinga Cab, Mumbai to 5 Jyotirlinga Tour Package, Mumbai to 5 Jyotirlinga Taxi Service, Mumbai to 5 Jyotirlinga Cab Service, Mumbai to 5 Jyotirlinga Darshan, Mumbai to 5 Jyotirlinga Tour, Mumbai to 5 Jyotirlinga Cab Booking, Mumbai to 5 Jyotirlinga Taxi Booking, Mumbai to 5 Jyotirlinga Car Rental, Mumbai to 5 Jyotirlinga Outstation Cab, Mumbai Jyotirlinga Tour Package"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/11.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Shreesha Tours & Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Shreesha Tours & Travels</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shreesha Tours & Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918355835813 " className="pc-call">+91 8355835813 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919930929439 " className="pc-call">+91 9930929439 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919022432779 " className="pc-call">+91 9022432779 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91919930929439 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918355835813 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@shreeshatravels.com" className="pc-email">
                                            booking@shreeshatravels.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Shreesha Tours & Travels</strong><br />
                                            Office 125, Saishraddha CHS,
                                            Plot No 47, Near Koparkhairane Police Station,
                                            Sector 5, Sector 4,Ghansoli, Navi Mumbai,
                                            Maharashtra, India- 400701




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Mumbaitofivejyotilingacab;